type LoaderFileList = {
  iterate: (fn: (file: { key?: string; type?: string }) => boolean | void) => void;
};

export type TextureLoaderLike = {
  list: LoaderFileList;
  inflight: LoaderFileList;
  queue: LoaderFileList;
  isLoading: () => boolean;
};

/** True when an image with this key is already queued or inflight on the scene loader. */
export function isImageTextureQueued(loader: TextureLoaderLike, key: string): boolean {
  let queued = false;
  const match = (file: { key?: string; type?: string }): boolean | void => {
    if (file.key === key && file.type === "image") {
      queued = true;
      return false;
    }
  };
  loader.list.iterate(match);
  if (!queued && loader.isLoading()) {
    loader.inflight.iterate(match);
    if (!queued) loader.queue.iterate(match);
  }
  return queued;
}
